import { Box, CircularProgress, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import LayoutTable from "./layout/Table";
import { useGlobalContext } from "../../App";
import { getAllCollections } from "../../services/collection";
import AddCollection from "./components/AddCollection";
import Search from "../../shared/components/Search";
import { FilterIconSvg } from "../../assets/icons/FilterIconSvg";
import { PagesIconForTabSvg } from "../../assets/icons/pagesIcon/PagesIconForTabSvg";
import { LayersIconSvg } from "../../assets/icons/LayersIconSvg";
import ScreenIconSvg from "../../assets/icons/screenIcons/ScreenIconSvg";

type Props = {};

export interface ActionMenuProps {
  title: string;
  action: () => void;
  actionTitle: string;
}

const tableRef = React.createRef<any>();

const CollectionsList = (props: Props) => {
  const {
    addCollectionUI,
    setCollectionFiltersPopupOpen,
    collectionFiltersPopupOpen,
  } = useGlobalContext();
  const key = useRef("Components");
  const columnItems = [
    { id: "Icon", label: "Icon" },
    { id: "Name", label: "Name" },
    { id: `No. of ${key.current}`, label: `No. of ${key.current}` },
    { id: "Status", label: "Status" },
  ];

  const [loading, setLoading] = useState(true);
  const [collectionsList, setCollectionsList] = useState<any>([]);
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState("");

  // TabPanel handling states and functions
  const tabs = [
    {
      label: "Components",
      icon: <LayersIconSvg color="rgba(255, 255, 255, 0.5)" />,
      activeIcon: <LayersIconSvg color="#0C0C0C" />,
      value: 0,
    },
    {
      label: "Pages",
      icon: <PagesIconForTabSvg />,
      activeIcon: <PagesIconForTabSvg color="#0C0C0C" />,
      value: 1,
    },
    {
      label: "Screens",
      icon: <ScreenIconSvg />,
      activeIcon: <ScreenIconSvg color="#0C0C0C" />,
      value: 2,
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setLoading(true);

    // Fetch collections based on selected tab
    if (newValue === 0) {
      key.current = "Components";
      fetchCollections({ includeComponents: true, type: "COMPONENT" });
    } else if (newValue === 1) {
      key.current = "Pages";
      fetchCollections({ includePages: true, type: "PAGE" });
    } else if (newValue === 2) {
      key.current = "Screens";
      fetchCollections({ includeScreens: true, type: "SCREEN" });
    }
  };

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  const fetchCollections = async (filters?: any) => {
    setLoading(true);

    await getAllCollections(filters)
      .then((res: any) => {
        // Sort by "order" in asc
        const sortedCollections = {
          ...res,
          paginatedCollections: res?.paginatedCollections?.sort(
            (a: any, b: any) => a.order - b.order
          ),
        };
        setLoading(false);
        setCollectionsList(sortedCollections);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (value === 0) {
      fetchCollections({ includeComponents: true, type: "COMPONENT" });
    } else if (value === 1) {
      fetchCollections({ includePages: true, type: "PAGE" });
    } else if (value === 2) {
      fetchCollections({ includeScreens: true, type: "SCREEN" });
    }
  }, []);

  const handleRefreshData = () => {
    if (value === 0) {
      fetchCollections({ includeComponents: true, type: "COMPONENT" });
    } else if (value === 1) {
      fetchCollections({ includePages: true, type: "PAGE" });
    } else if (value === 2) {
      fetchCollections({ includeScreens: true, type: "SCREEN" });
    }
  };
  useEffect(() => {}, [collectionsList]);

  return (
    <>
      {!addCollectionUI ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            paddingTop: "32px",
            paddingBottom: "30px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "85%",
              mb: "18px",
            }}
          >
            {/* Tabs options */}
            <Box sx={{ width: "fit-content" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="primary"
                TabIndicatorProps={{ style: { display: "none" } }}
                TabScrollButtonProps={{
                  style: {
                    color: "white",
                  },
                }}
                visibleScrollbar={true}
                sx={{
                  borderColor: "divider",
                  fontWeight: "500",
                  color: "white",
                  flex: 1,
                  width: "100%",
                  minHeight: "fit-content",
                  "& .MuiTabs-flexContainer": {
                    display: "flex",
                    flexDirection: "row",
                    gap: "12px",
                    padding: "0px",
                  },
                }}
                aria-label="scrollable auto tabs example"
              >
                {tabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    disableRipple
                    sx={{
                      textTransform: "none",
                      fontWeight: "500",
                      color: "white",
                      padding: "0px !important",
                    }}
                    label={
                      <Box
                        sx={{
                          boxShadow:
                            value === tab.value
                              ? "inset 0px 0px 0px 1px #CCFF00"
                              : "inset 0px 0px 0px 1px #3D3D3D",
                          bgcolor: value === tab.value ? "#CCFF00" : "#141414",
                          color: value === tab.value ? "black" : "#8B8B8B",
                          borderRadius: "100px",
                          minHeight: "46px !important",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "12px 16px",
                        }}
                      >
                        <Typography
                          sx={{
                            display: "flex",
                            gap: "8px",
                            fontSize: "16px",
                            lineHeight: "22px",
                          }}
                          fontWeight={600}
                        >
                          {value === tab.value ? tab.activeIcon : tab.icon}
                          {tab.label}
                        </Typography>
                      </Box>
                    }
                  />
                ))}
              </Tabs>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Box
                // onKeyDown={handleKeyDown}
                sx={{ display: "flex", height: "52px" }}
              >
                <Search
                  searchFormStyles={{
                    minHeight: "22px",
                  }}
                  style={{
                    minHeight: "52px",
                    color: "white",
                  }}
                  icon={true}
                  placeholder="Search"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </Box>

              <Box
                onClick={() => {
                  setCollectionFiltersPopupOpen(
                    collectionFiltersPopupOpen ? false : true
                  );
                }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "52px",
                  height: "52px",
                  borderRadius: "14px",
                  bgcolor: "#141414",
                  boxShadow: "inset 0px 0px 0px 2px #3D3D3D",
                  cursor: "pointer",
                }}
              >
                <FilterIconSvg />
              </Box>
            </Box>
          </Box>

          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                right: 0,
                left: 0,
                bottom: 0,
                top: 120,
                height: "100%",
              }}
            >
              <CircularProgress
                size={24}
                sx={{
                  color: "white",
                  marginRight: "12px",
                }}
              />
            </Box>
          ) : collectionsList?.paginatedCollections?.length > 0 ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  // overflowY: "scroll",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <Box
                    sx={{
                      width: "85%",
                    }}
                  >
                    <LayoutTable
                      loading={loading}
                      rows={collectionsList?.paginatedCollections}
                      columns={columnItems}
                      handleRefreshData={handleRefreshData}
                    />
                  </Box>
                </Box>
              </Box>
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "60vh",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography sx={{ color: "white" }} variant="h5">
                No Collections to display
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        // ------------Add collections Form-----------
        <>
          <Box>
            <AddCollection handleRefreshData={handleRefreshData} />
          </Box>
        </>
      )}
    </>
  );
};

export default CollectionsList;
